(function ($) {
	'use strict';
	var acceptCookies = {

		init: function () {
			var cookieInfo = $('.cookie-info');

			$('.js-cookie-btn').on("click", function () {
				cookieInfo.hide();
				acceptCookies.acceptCookies();
			});

			if (this.hasAcceptedCookies()) {
				cookieInfo.hide();
			} else {
				cookieInfo.show();
			}
		},

		hasAcceptedCookies: function () {
			return $.cookie('accept-cookies');
		},

		acceptCookies: function () {
			$.cookie("accept-cookies", true, {
				expires: 356,
				path: '/'
			});
		}

	};
	
	// acceptCookies.init(); 
	
})(jQuery);

